import React from 'react'
import { Link } from 'react-router-dom'
import { t } from '../i18n'
import { track } from '../Utils/analytics'
import { ChevronRight } from './Icons'

/* Orange topic chip on a card: shown only when the story belongs to a topic. */
export default function TopicTag({ topic }) {
  if (!topic) return null
  return (
    <Link
      to={`/tema/${topic.slug}`}
      className="topic-tag"
      aria-label={t('card.topicLabel', { name: topic.shortTitle })}
      onClick={() => track('topic_open', { from: 'card', topic: topic.slug })}
    >
      <span className="topic-dot" aria-hidden="true" />
      <span className="topic-tag-name">{topic.shortTitle}</span>
      <ChevronRight size={14} strokeWidth={2.5} />
    </Link>
  )
}
